var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.375H1.25C1.10082 0.375 0.957742 0.434263 0.852252 0.539753C0.746763 0.645242 0.6875 0.788316 0.6875 0.9375V10.5C0.6875 10.7984 0.806026 11.0845 1.017 11.2955C1.22798 11.5065 1.51413 11.625 1.8125 11.625H14.1875C14.4859 11.625 14.772 11.5065 14.983 11.2955C15.194 11.0845 15.3125 10.7984 15.3125 10.5V0.9375C15.3125 0.788316 15.2532 0.645242 15.1477 0.539753C15.0423 0.434263 14.8992 0.375 14.75 0.375ZM13.3037 1.5L8 6.36211L2.69633 1.5H13.3037ZM14.1875 10.5H1.8125V2.21648L7.61961 7.53984C7.72338 7.63511 7.85913 7.68797 8 7.68797C8.14087 7.68797 8.27662 7.63511 8.38039 7.53984L14.1875 2.21648V10.5Z",
    fill: "#979099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.b5afda28e8549af84f74eadcebaaa8e9.svg";
export { ForwardRef as ReactComponent };